import { __decorate, __metadata } from "tslib";
import { Component, Inject, Prop, Provide } from "vue-property-decorator";
import { LvValidationResult } from "../validator/LvValidationResult";
import { SYM_LV_FORM } from "../form/LvForm.vue";
/**
 * Injection symbol provided by the LvFormItem component
 */
export const SYM_LV_FORM_ITEM = Symbol("LvFormItem");
export const COMPONENT_NAME = "LvFormItem";
/**
 * An item of a form. Displays validation messages.
 */
let LvFormItem = class LvFormItem extends LvValidationResult {
    get self() {
        return this;
    }
    get classList() {
        return [
            this.required ? "is-required" : null,
            this.hasValue ? "has-value" : null,
            this.validationState == "info" ? "has-info" : null,
            this.validationState == "error" ? "has-error" : null,
        ].filter(x => x != null);
    }
};
__decorate([
    Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LvFormItem.prototype, "showLabel", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LvFormItem.prototype, "required", void 0);
__decorate([
    Provide(SYM_LV_FORM_ITEM),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LvFormItem.prototype, "self", null);
__decorate([
    Inject({ default: null, from: SYM_LV_FORM }),
    __metadata("design:type", Object)
], LvFormItem.prototype, "form", void 0);
LvFormItem = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvFormItem);
export default LvFormItem;
//# sourceMappingURL=script.js.map